import { get, post, put, remove } from '@/utils/request';
import type { 
  MemberInfo, 
  AddMemberInfoParam, 
  ModifyMemberInfoParam, 
  SearchMemberInfoParam, 
  PageDTO 
} from '../baseInfo/type';

const BASE_URL = '/cmp-doc/baseInfo/memberInfo';

/** 批量添加人员信息 */
export function saveMemberInfo(data: AddMemberInfoParam[]) {
  return post<any>(BASE_URL + '/save', data, {}, 'document');
}

/** 获取人员信息列表 */
export function getMemberInfoList(params: SearchMemberInfoParam) {
  return post<any>(BASE_URL + '/list', params, {}, 'document');
}

/** 删除人员信息 */
export function removeMemberInfo(memberIds: number[]) {
  return post<any>(BASE_URL + '/remove', memberIds, {}, 'document');
}

/** 批量修改人员信息 */
export function modifyMemberInfo(data: ModifyMemberInfoParam[]) {
  return post<any>(BASE_URL + '/modify', data, {}, 'document');
} 